let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("hPzOn"), load("cM9em"), load("fr9NE"), load("h2MrD"), load("bYT2S"), load("iNhRd")]).then(() => parcelRequire('aggrw'));